// extracted by mini-css-extract-plugin
module.exports = {"container":"CMNZcJoV2OsUaBuQvNEkL","groupsList":"mkEJmrpoT415zDDKzwcmC"};